export enum QuizResponseType {
  Initialize,
  Submit,
  Accept,
  AcceptRetake
}
